import React from 'react';
import LocationTemplate from './LocationTemplate';

const GreenvillePage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Greenville"
      stateName="North Carolina"
      countyName="Pitt"
      zipCodes={["27834", "27835", "27836", "27837", "27858", "27859"]}
      latitude={35.6127}
      longitude={-77.3664}
      population={87521}
      historicalFact="Founded in 1771 as 'Martinsborough,' renamed Greenville in 1786 in honor of Revolutionary War hero Nathanael Greene."
      nearbyTowns={[
        "Wilson, NC",
        "Rocky Mount, NC",
        "Winterville, NC",
        "Ayden, NC",
        "Farmville, NC",
        "Washington, NC",
        "Kinston, NC",
        "Tarboro, NC"
      ]}
    />
  );
};

export default GreenvillePage;